import axios from "axios";
import { store } from "../redux/store";

export const rockApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  timeout: 30000
});

let isRedirectingToLogin = false;

rockApi.interceptors.request.use((config) => {
  if (isRedirectingToLogin) {
    const controller = new AbortController();
    controller.abort();
    config.signal = controller.signal;
  }
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

rockApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isRedirectingToLogin) {
      isRedirectingToLogin = true;
      store.dispatch({ type: "AUTH/LOGOUT" });
    }
    return Promise.reject(error);
  }
);

export function unwrapRockResponse(resp) {
  const payload = resp?.data;
  if (payload && typeof payload === "object" && "success" in payload) {
    if (payload.success) return payload.data;
    const message = payload.message || "API error";
    const err = new Error(message);
    err.payload = payload;
    throw err;
  }
  return payload;
}

